<template>
  <div id="user-page" class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>メディア一覧</h5>
        <h5>フォルダ名：{{ folderInfo.folderName }}</h5>
      </div>
      <div class="col-5">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">戻る</button>
        <button id="destroyBtn" type="button" class="btn-sm btn-outline-danger btn_right" v-if="isAdmin && folderInfo.isPrivate && message" v-on:click="destroy">個人フォルダを削除</button>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-10">
        <div class="row">

          <div class="col-3 photo" v-for="photo in processedPhotos" :key="photo.index">
            
            <div v-if="photo.type=='audio'">
              <div class="card card-height">
                <div class="card-img parent-position">
                  <div class="event-controller" v-if="photo.mediaPlayUrl" @click="startMediaStream(photo.mediaPlayUrl, photo.type)">
                    <svg class="thumbnail-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" height="100%" width="100%">
                      <path d="M12,3v9.28c-0.47,-0.17 -0.97,-0.28 -1.5,-0.28C8.01,12 6,14.01 6,16.5S8.01,21 10.5,21c2.31,0 4.2,-1.75 4.45,-4H15V6h4V3h-7z" style="fill:#00C3E0;" transform="translate(38, 38)" />
                      <path d="M8,5v14l11,-7z" style="fill:#000; opacity: 0.5;" transform="translate(38, 38)" />
                    </svg>
                  </div>
                </div>
                <p class="card-text">投稿者：{{ photo.user.userName }}</p>
                <p class="card-text">投稿日：{{ moment(photo.createdAt) }}</p>
                <p class="card-text">期&emsp;限：{{ photo.deletedAt }}</p>
              </div>
              <button type="button" class="btn-sm btn-light dl-btn" v-on:click="downloadAudio(photo.blobUrl, photo.mediaPath)">ダウンロードする</button>
            </div>

            <div v-else-if="photo.type=='video'">
              <div class="card card-height">
                <div class="card-img parent-position">
                  <div class="event-controller" v-if="photo.mediaPlayUrl" @click="startMediaStream(photo.mediaPlayUrl, photo.type)">
                    <img class="card-img-thumbnail" :src="photo.thumbnailBlobUrl">
                    <svg class="thumbnail-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" height="100%" width="100%">
                      <path d="M8,5v14l11,-7z" style="fill:#000; opacity: 0.5;" transform="translate(38, 38)" />
                    </svg>
                  </div>
                </div>
                <p class="card-text">投稿者：{{ photo.user.userName }}</p>
                <p class="card-text">投稿日：{{ moment(photo.createdAt) }}</p>
                <p class="card-text">期&emsp;限：{{ photo.deletedAt }}</p>
              </div>
              <button type="button" class="btn-sm btn-light dl-btn" v-on:click="downloadVideo(photo.blobUrl, photo.mediaPath)">ダウンロードする</button>
            </div>

            <div v-else>
              <a class="card card-height" :href="photo.blobUrl" target="_blank" rel="noopener noreferrer">
                <img class="card-img" :src="photo.blobUrl">
                <p class="card-text">投稿者：{{ photo.user.userName }}</p>
                <p class="card-text">投稿日：{{ moment(photo.createdAt) }}</p>
                <p class="card-text">期&emsp;限：{{ photo.deletedAt }}</p>
              </a>
              <button type="button" class="btn-sm btn-light dl-btn" v-on:click="download(photo.blobUrl, photo.imagePath)">ダウンロードする</button>
            </div>

          </div>

        </div>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev">
              <a v-if="navigationButtonsEnabled" class="btn page-link rounded-pill" v-on:click="goPrev">&larr; 前</a>
              <p v-else class="btn page-link rounded-pill">&larr; 前</p>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext">
              <a v-if="navigationButtonsEnabled" class="btn page-link rounded-pill" v-on:click="goNext">次 &rarr;</a>
              <p v-else class="btn page-link rounded-pill">次 &rarr;</p>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'
import Hls from 'hls.js'

export default {
  name: 'Photo',
  mixins: [sessions,path,headers],
  props: ['realms'],
  src: {
    authority
  },
  data: function(){
    return {
      message: '',
      blobUrl: "",
      photos: [],
      gridCount: 0,
      currentIndex: 0,
      limit: 8,
      folderInfo: '',
      navigationButtonsEnabled: true
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.search(true)
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/photo/folder/index'))
        }
      }
    )
  },
  computed: {
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    },
    isAdmin: function () {
      var overAdmin = authority.isAdmin.concat(authority.isSuper)
      return overAdmin.includes(Number(this.$store.state.user.privilege))
    },
    processedPhotos: function () {
      var photos = this.photos;
      return photos;
    }
  },
  methods: {
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/photo/folder/index'))
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          this.disableNextButton();
          if(isInit){
            this.currentIndex = 0
          }
          var offset = this.currentIndex * this.limit
          var accessToken = this.getAccessToken(this.$cognito,session)
          var folderId = this.$route.params.id;
          axios
            .get("/api/media/management/list/" + folderId + "/" + offset, {
                headers: this.headers(accessToken)
            }).then(response => {
              var res = response.data
              if(res.errorMessage) {
                this.message = res.errorMessage
              } else {
                this.folderInfo = res.data.folderInfo;
                if(res.data.photos.length == 0) {
                  this.message = "表示可能なメディアが存在しません。"
                  return
                }
                this.photos = res.data.photos;
                this.gridCount = this.photos.length
                let processedCount = 0;

                this.photos.forEach((photo, index) => {
                  if (photo.type == "video") this.getVideoThumbnail(photo, index, accessToken);
                  
                  axios.get(this.setDownloadContentApiPath(photo), {
                    headers: this.headers(accessToken),
                    responseType: "blob"
                  }).then(response => {
                    var res = response.data;
                    if(res.errorMessage) {
                      this.message = res.errorMessage
                    } else {
                      this.photos[index].blobUrl = URL.createObjectURL(response.data)
                      if (photo.type == "audio" || photo.type == "video") this.photos[index].mediaPlayUrl = photo.mediaPath.replace('api/media','api/media/management');
                      this.photos = this.photos.map((photo) => { return photo })
                      
                      processedCount ++;
                      if (processedCount == this.gridCount) this.enableNextButton();
                    }
                  }).catch(err => {
                    this.enableNextButton();
                    this.message = err.message
                  })
                })
              }
            })
            .catch(err => {
              this.enableNextButton();
              this.message = err.message
            })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    getVideoThumbnail(photo, index, accessToken) {
      const apiPath = photo.imagePath.replace('api/media','api/media/management/video/thumbnail');
      axios.get(apiPath, { headers: this.headers(accessToken), responseType: "blob" })
      .then(response => {
        if (response.data.errorMessage) this.message = response.data.errorMessage;
        else {
          this.photos[index].thumbnailBlobUrl = URL.createObjectURL(response.data);
          this.photos = this.photos.map((photo) => { return photo });
        }
      })
      .catch(error => {
        this.enableNextButton();
        this.message = error
      });
    },
    setDownloadContentApiPath(photo) {
      if (photo.type == "image") return photo.imagePath.replace('api/photo','api/photo/management');
      else if (photo.type == "audio") return photo.mediaPath.replace('api/media','api/media/management/audio');
      else return photo.mediaPath.replace('api/media','api/media/management/video');
    },
    startMediaStream(mediaPlayUrl, type) {
      if (mediaPlayUrl == undefined) return;
      this.$cognito.isAuthenticated().then(async (session) => {
        if(session){
          if (Hls.isSupported()) {
            const newTab = window.open("", mediaPlayUrl);
            newTab.document.write(`
              <html>
                <body style="margin: 0; padding: 0;">
                  <div style="display: flex; justify-content: center; align-items: center; height: 100vh; background-color: black;">
                    ${this.setMediaPlayerElement(type)}
                  </div>
                </body>
              </html>
            `);
            
            const accessToken = this.getAccessToken(this.$cognito, session);
            const hls = new Hls({ 
              xhrSetup : (xhr) => { xhr.setRequestHeader('x-access-token', accessToken) }
            });
            
            const m3u8Url = `${window.location.origin}${mediaPlayUrl}`;
            const videoElement = newTab.document.getElementById("mediaPlayer");
            hls.loadSource(m3u8Url);
            hls.attachMedia(videoElement);
            hls.on(Hls.Events.MANIFEST_PARSED, () => { videoElement.play() });

          } else {
            this.message = "お使いのブラウザはストリーミング再生できません。";
          }
        }
      })
    },
    setMediaPlayerElement(type) {
      if (type == "video") return `<video id="mediaPlayer" controls></video>`
      else return `<audio id="mediaPlayer" controls></audio>`
    },
    download(blobUrl, imagePath) {
      var link = document.createElement('a')
      link.href = blobUrl
      link.download = imagePath.split('/').slice(-1)[0].replace('webp','jpeg')
      link.click()
    },
    downloadAudio(blobUrl, mediaPath) {
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = mediaPath.split('/').slice(-1)[0].replace('m3u8', 'mp3');
      link.click();
    },
    downloadVideo(blobUrl, mediaPath) {
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = mediaPath.split('/').slice(-1)[0].replace('m3u8', 'mp4');
      link.click();
    },
    enableNextButton() {
      this.navigationButtonsEnabled = true;
    },
    disableNextButton() {
      this.navigationButtonsEnabled = false;
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    },
    moment: function (date) {
      return this.$moment(date).format('M月D日 HH:mm')
    },
    destroy() {
      if(confirm('この操作は取り消せませんがよろしいですか?')){
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var folderId = this.$route.params.id;
          axios.delete("/api/folder/management/private/" + folderId, {
              headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('削除されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/photo/folder/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    },
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#destroyBtn {
  float: right;
}
#backBtn {
  float: right;
  margin-left: 10px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.photo {
  text-align: center;
  margin-bottom: 0.5rem;
}
.card-height { min-height: 30rem; }
.card-img {
  width: 100%;
  height: 25rem;
  margin-bottom: 0.5rem;
}
.card-img-thumbnail {
  width: 100%;
  height: 100%;
}
.card-text {
  color: black;
  align-self: flex-start;
  margin: 0%;
}
.event-controller {
  height: 25rem;
}
.parent-position { position: relative; }
.thumbnail-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.dl-btn {
  margin-top: 0.5rem;
  margin-bottom: 2rem;
}
</style>